export default __webpack_public_path__ + "static/media/pt_same_articles_vertical.3679aeaa.png";